const colors = [
    '#337ACE',
    '#e49a1c',
    '#377eb8',
    '#46A043',
    '#984ea3',
    '#39CEE8',
    '#a65628',
    '#f781bf',
    '#3CC735',
    '#4F2BD6'
];

const circleMarkerStyle = {
    radius: 5,
    color: '#000',
    weight: 0,
    opacity: 1,
    fillOpacity: 0.9
};

export default class ColorHandler {

    private cycleThroughColors: boolean;
    private colorCursor = 0;
    private featureTypeColors: { [key: number]: string } = {};

    constructor(cycleThroughColors: boolean) {
        this.cycleThroughColors = cycleThroughColors;
    }

    getNewColor() {
        const index = this.cycleThroughColors ? (this.colorCursor++)%colors.length : 0;

        return colors[index];
    }

    colorForFeatureType(featureTypeId: number) {
        if (!this.featureTypeColors[featureTypeId]) {
            this.featureTypeColors[featureTypeId] = this.getNewColor();
        }

        return this.featureTypeColors[featureTypeId];
    }

    circleMarkerForFeatureType(featureTypeId: number) {
        const color = { fillColor: this.colorForFeatureType(featureTypeId) };

        return { ...color, ...circleMarkerStyle };
    }

}
